import React from 'react';

import { TRecommendation } from '@/services/requests/Recommendation/types/template1';

type TProps = {
  data: TRecommendation;
};

export function Title({ data }: TProps) {
  return (
    <h3
      className="vitrine-template1__title"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: data.title,
      }}
    />
  );
}
